import { css, type SerializedStyles } from '@emotion/react'
import { toolbarClasses } from '@mui/material'
import { type Theme } from '@mui/material/styles'
import { rem, size } from 'polished'

import { APPBAR_HEIGHT, APPBAR_LG_HEIGHT } from '@Styles/constants/layout'
import { getFocusVisibleIconButtonStyle } from '@Styles/focus'

export const appBar = (theme: Theme, isInModal = false): SerializedStyles =>
  css({
    height: APPBAR_HEIGHT,
    justifyContent: 'center',
    padding: isInModal ? theme.spacing(2) : theme.spacing(2, '0'),
    [theme.breakpoints.up('lg')]: {
      height: APPBAR_LG_HEIGHT,
    },
  })

export const appBarContainer = (theme: Theme): SerializedStyles =>
  css({
    padding: theme.spacing('0', 2),
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing('0', 3),
    },
  })

export const appBarProminent = (theme: Theme, isInModal = false): SerializedStyles =>
  css({
    justifyContent: 'center',
    minHeight: APPBAR_HEIGHT,
    padding: isInModal ? theme.spacing(2) : theme.spacing(2, '0'),
    [theme.breakpoints.up('lg')]: {
      minHeight: APPBAR_LG_HEIGHT,
    },
  })

export const toolBar = (theme: Theme): SerializedStyles =>
  css({
    [`&.${toolbarClasses.root}`]: {
      minHeight: 0,
      padding: 0,
      [theme.breakpoints.down('md')]: {
        height: rem(24),
      },
      [theme.breakpoints.up('md')]: {
        height: rem(40),
      },
    },
  })

export const appBarAction = (theme: Theme): SerializedStyles =>
  css({
    flexShrink: 0,
    justifyContent: 'end',
    marginRight: `-${theme.spacing(2)}`,
    minWidth: 0,
  })

export const children = (theme: Theme): SerializedStyles =>
  css({
    marginTop: theme.spacing(2),
  })

export const backButtonWithBookingForm = css({
  marginTop: rem(25.6),
})

export const backButton = (theme: Theme): SerializedStyles =>
  css({
    '&:focus-visible::before': getFocusVisibleIconButtonStyle(theme.palette.primary.contrastText, rem(-4)),
    '&:hover': {
      backgroundColor: theme.customPalette.onElements.selected,
    },
    alignSelf: 'auto',
    backgroundColor: theme.palette.primary.contrastText,
    // Pour modifier la couleur du ripple sur un iconButton il faut définir la couleur
    color: theme.palette.primary.main,
    marginLeft: 0,
    marginRight: theme.spacing(2),
    padding: theme.spacing(1),
    ...size(rem(32)),
    [theme.breakpoints.up('md')]: {
      ...size(rem(40)),
    },
  })

export const arrowIcon = (theme: Theme): SerializedStyles =>
  css({
    fill: theme.palette.primary.main,
  })

export const content = css({
  flexGrow: 1,
})
